import { Coffee, Phone, MessageSquareText } from "lucide-react";
import { CONTACT } from "@/lib/api";
import { Reveal } from "@/components/landing/Reveal";

const STEPS = [
  { n: "1", title: "PICK A SLOT", copy: "Live weekday times. 7AM legends score a free coffee." },
  { n: "2", title: "WE FIND IT", copy: "$360 first half-hour. Spy kit in tow." },
  { n: "3", title: "WE FIX IT", copy: "Upfront repair quote. Lifetime labour warranty." },
];

export const Booking = () => {
  return (
    <section id="book" data-testid="booking-section" className="py-24 sm:py-32 bg-tpink noise-overlay relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14">
        <div>
          <Reveal>
            <p className="font-bold text-xs tracking-[0.3em] text-brand uppercase mb-4">Chapter 06 — Lock it in</p>
            <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.9]">
              PICK YOUR SLOT. <span className="text-brand">WE'LL FIND THE DRIP.</span>
            </h2>
            <p className="mt-6 text-white/90 text-base sm:text-lg max-w-lg">
              The only live-availability booking in the Perth leak game. No phone tag. You pick, we appear.
            </p>
          </Reveal>

          <div className="mt-10 space-y-5">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08}>
                <div data-testid={`booking-step-${s.n}`} className="flex gap-5 items-start">
                  <span className="font-bebas text-5xl text-navy leading-none w-10 shrink-0">{s.n}</span>
                  <div>
                    <h3 className="font-bebas text-2xl text-white tracking-wide">{s.title}</h3>
                    <p className="text-sm text-white/85 max-w-md">{s.copy}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="mt-10">
            <div className="rounded-3xl bg-white/15 border border-white/25 p-6 flex items-start gap-4">
              <Coffee className="w-8 h-8 text-navy shrink-0" />
              <div>
                <p className="font-bebas text-2xl text-white tracking-wide">THE COFFEE FIX</p>
                <p className="text-sm text-white/85">
                  Nab the first 7AM booking of the day and we'll bring a free coffee from a local café to your door.
                  First in, best caffeinated.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.25} className="mt-8 flex flex-wrap gap-3">
            <a data-testid="booking-call-link" href={CONTACT.phoneHref} className="inline-flex items-center gap-2 rounded-full border-2 border-white/25 text-white font-bebas text-xl tracking-wide px-6 py-2.5 hover:border-brand hover:text-brand transition-colors duration-300">
              <Phone className="w-4 h-4" /> CALL {CONTACT.phone}
            </a>
            <a data-testid="booking-text-link" href={CONTACT.textHref} className="inline-flex items-center gap-2 rounded-full border-2 border-white/25 text-white font-bebas text-xl tracking-wide px-6 py-2.5 hover:border-brand hover:text-brand transition-colors duration-300">
              <MessageSquareText className="w-4 h-4" /> TEXT {CONTACT.text}
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="rounded-3xl bg-white p-3 sm:p-4 shadow-2xl shadow-black/30 overflow-hidden">
            <iframe
              data-testid="booking-widget-iframe"
              src="https://plumbing-electrical-booking-widget.vercel.app/embed"
              title="Book a plumber or electrician"
              width="100%"
              style={{ minHeight: "720px", border: 0, width: "100%", display: "block" }}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
